import { ShipmentOrderSummary } from 'src/entities/ShipmentOrderList.entity';

import { ShipmentOrderGridRow } from './Columns';

/**
 * 一覧のレスポンス 1 件を DataGrid の行にする。
 *
 * Why not index.tsx に置いたまま: 行の組み立てだけを試したいが、index.tsx は Presenter 全体なので
 * 描画しないと呼べない。同階層の buildShipperSummaryPrintHtml.ts と同じ形で切り出す（#405 決定 5）
 */
export const toShipmentOrderGridRow = (shipment: ShipmentOrderSummary): ShipmentOrderGridRow => ({
  id: shipment.id,
  code: shipment.code || String(shipment.id),
  shipper_name: shipment.shipper?.name ?? '--',
  loading_name: shipment.pickup.location?.name ?? '--',
  loading_address: shipment.pickup.location?.address ?? '--',
  relay_location_name: shipment.relay?.location?.name ?? '--',
  relay_location_address: shipment.relay?.location?.address ?? '--',
  unloading_internal_location_code: shipment.delivery.location?.internal_location_code ?? '--',
  unloading_name: shipment.delivery.location?.name ?? '--',
  unloading_address: shipment.delivery.location?.address ?? '--',
  pickup_date: shipment.pickup.date ?? null,
  delivery_date: shipment.delivery.date ?? null,
  product_count: shipment.cargo.product_count ?? null,
  quantity: shipment.cargo.quantity ?? null,
  weight_kg: shipment.cargo.weight_kg ?? null,
  volume_m3: shipment.cargo.volume_m3 ?? null,
  billing_amount_total: shipment.billing?.total_amount ?? 0,
  registration_user: shipment.registration.user_name ?? '--',
  registration_datetime: shipment.registration.recorded_at ?? null,
  updated_datetime: shipment.updated_at ?? shipment.registration.updated_at ?? null,
  status_label: shipment.status_label,
});
